import { z } from 'zod';

export const AdminSignInSucceededPayloadSchema = z.object({
  userId: z.string().min(1),
});

export const AdminSignInFailedPayloadSchema = z.object({
  userId: z.string().min(1).optional(),
  reason: z.string().min(1),
});

export const AdminSignOutPayloadSchema = z.object({
  userId: z.string().min(1),
});

// One operator call to an admin-MCP counterpart, acting for a member (IMM-1059). Audited always, reads included:
// the operator is the actor, the member the aggregate. Arguments are deliberately NOT carried — they hold the
// customer's own data, and the audit row must record who acted for whom, not copy what they read.
export const ActingMemberToolCalledPayloadSchema = z.object({
  adminId: z.string().min(1),
  credentialId: z.string().uuid(),
  workspaceId: z.string().uuid(),
  memberId: z.string().uuid(),
  toolId: z.string().min(1),
  toolName: z.string().min(1),
  kind: z.enum(['read', 'write']),
});
